import type { ImplementedCopilotFeatures, CopilotSettingsStore } from 'owa-copilot-settings-store';
import { getApplicationSettings } from 'owa-application-settings';
import isCopilotFeatureEnabled from './isCopilotFeatureEnabled';
import createStoreCheckForGenericEnablement from './createStoreCheckForGenericEnablement';
import type { MailboxInfo } from 'owa-client-types';

type RewriteScenarios = Extract<ImplementedCopilotFeatures, 'Rewrite'>;
const isAutoRewriteEnabled = (): ((
    scenario: 'Rewrite',
    mailboxInfo: MailboxInfo,
    skipLanguageCheck?: boolean,
    shouldIgnoreUserPreferences?: boolean
) => boolean | undefined) =>
    createStoreCheckForGenericEnablement<RewriteScenarios, boolean>(
        'AutoRewrite',
        isAutoRewriteEnabledInternal
    );

export default isAutoRewriteEnabled;

function isAutoRewriteEnabledInternal(
    store: CopilotSettingsStore,
    _language: string,
    scenario: RewriteScenarios,
    mailboxInfo: MailboxInfo,
    skipLanguageCheck?: boolean
): boolean {
    if (store.isEnabled) {
        const featureEnabled = store.featureInfo.get(scenario);
        if (featureEnabled?.isEnabled) {
            const appSettings = getApplicationSettings('Copilot', mailboxInfo);
            return (
                !!isCopilotFeatureEnabled(
                    scenario,
                    mailboxInfo,
                    skipLanguageCheck ?? appSettings.enableMultiLanguage
                ) &&
                !!featureEnabled.capabilities &&
                'autoRewriteStaticPrompt' in featureEnabled.capabilities &&
                featureEnabled.capabilities.autoRewriteStaticPrompt
            );
        }
    }
    return false;
}
